import { API_CONFIG } from '../config/api';

const noop = () => {};

export const configureConsoleLogging = () => {
  const debugQueryEnabled = new URLSearchParams(window.location.search).has('debug');

  if (API_CONFIG.debug || debugQueryEnabled || process.env.NODE_ENV === 'development') {
    return;
  }

  console.log = noop;
  console.info = noop;
  console.debug = noop;
};
